import { render, staticRenderFns } from "./CategoryListItemProduct.vue?vue&type=template&id=087ae470&scoped=true"
import script from "./CategoryListItemProduct.vue?vue&type=script&lang=js"
export * from "./CategoryListItemProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ae470",
  null
  
)

export default component.exports